module.exports = __webpack_public_path__ + "img/link_video4.16b5f0ca.png";